import gql from "graphql-tag";

const CREATE_TYPE_FORM_RESPONSES = gql`
  mutation (
    $landed_at: String!
    $submitted_at: String!
    $form_id: String!
    $form_title: String!
    $chi_rating_question: String!
    $chi_rating_answer: String!
    $chi_rating: String!
    $chi_score: String!
    $issue_resolved_question: String!
    $issue_resolved_answer: String!
    $escalate_question: String!
    $escalate_answer: String
    $negative_feedback_question: String!
    $negative_feedback_answer: String
    $neutral_feedback_question: String!
    $neutral_feedback_answer: String
    $positive_feedback_question: String!
    $positive_feedback_answer: String
    $call_uuid: String!
    $is_web_chat: Boolean
    $contact_channel: String!
    $response_date: String!
  ) {
    createTypeFormResponses(
      input: {
        landed_at: $landed_at
        submitted_at: $submitted_at
        form_id: $form_id
        form_title: $form_title
        chi_rating_question: $chi_rating_question
        chi_rating_answer: $chi_rating_answer
        chi_rating: $chi_rating
        chi_score: $chi_score
        issue_resolved_question: $issue_resolved_question
        issue_resolved_answer: $issue_resolved_answer
        escalate_question: $escalate_question
        escalate_answer: $escalate_answer
        negative_feedback_question: $negative_feedback_question
        negative_feedback_answer: $negative_feedback_answer
        neutral_feedback_question: $neutral_feedback_question
        neutral_feedback_answer: $neutral_feedback_answer
        positive_feedback_question: $positive_feedback_question
        positive_feedback_answer: $positive_feedback_answer
        call_uuid: $call_uuid
        is_web_chat: $is_web_chat
        contact_channel: $contact_channel
        response_date: $response_date
      }
    ) {
      call_uuid
      response_date
    }
  }
`;

export default CREATE_TYPE_FORM_RESPONSES;
